module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-request-appointment"
  }, [_c('div', {
    staticClass: "modal-request-appointment__bg"
  }, [_c('div', {
    staticClass: "modal-request-appointment__container"
  }, [_c('div', {
    staticClass: "modal-request-appointment__close",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_vm._v("Close")]), _c('div', {
    staticClass: "modal-request-appointment__body"
  }, [_c('div', {
    staticClass: "modal-request-appointment__title"
  }, [_vm._v("Request Appointment")]), _c('div', {
    staticClass: "modal-request-appointment__form"
  }, [_c('FormRequestAppointment')], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d9af9468","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/modal/modal-request-appointment/modal-request-appointment.pug
// module id = 555
// module chunks = 1